export default "__VITE_ASSET__Dyxy0I0N__"